import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Config from '../Config';
import Cookies from 'js-cookie';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';

function Adview() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    let { id } = useParams();

    const [add, setadd] = useState([]);
    const getinfo = async (e) => {
        const res = await fetch(`${Config.apiurl}/api/v1/crm/ad/get-ad/${id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
        });
        if (res.status === 200) {
            const data = await res.json();

            setadd(data.data);

        }
        else if (res.status === 401) {
            handleUnauthorized();
            getinfo();
        }
        else {
            alert("error");

        }
    };

    useEffect(() => {
        getinfo();
    }, []);

    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='view_page_top'>
                            <Link to="/adslist">Ads list</Link>
                            <Link to={"/editad/" + id}>Edit</Link>
                        </div>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Ad View page</h4>

                                        <div className='row view_div_row'>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Title </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p> {add.adTitle}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Link </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {add.link}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Status </h6>
                                                    </div>

                                                    <div className='view_portion_p'>
                                                        <p>  {add.status === true ? "True" : "False"}</p>
                                                    </div>

                                                </div>
                                            </div>




                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Image </h6>
                                                    </div>
                                                    <div className='view_portion_p'>

                                                        <img src={add.adImage} style={{ width: "100px", height: "100px", marginTop: "10px", marginRight: "5px" }} />

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Adview
